// import "@babel/polyfill"
import Vue from 'vue'
import Vuex from 'vuex'
import Antd from 'ant-design-vue'
import Viser from 'viser-vue'
import VueDOMPurifyHTML from 'vue-dompurify-html'
import App from './App.vue'
import 'ant-design-vue/dist/antd.css'
import router from './router'
import store from './store'
import '../static/css/reset.css'
import axios from 'axios'
import cookie from './commomFun/cookie.js'
import echarts from 'echarts'
import './utils/filter'
import { baseURL } from './utils/config'
import localforage from 'localforage'
// 引入图片预览组件
import vueImgPreview from 'hevue-img-preview'

localforage.config({
  name: 'selectedList'
})
Vue.prototype.$localForage = localforage
Vue.use(VueDOMPurifyHTML)
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
Vue.use(Antd)
Vue.use(Viser)
Vue.use(Vuex)
// 初始化图片预览组件
Vue.use(vueImgPreview)
//增加日志
window.vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

axios.defaults.baseURL = baseURL
//全局拦截器携带token
axios.interceptors.request.use(
  config => {
    // cookie：同浏览器登录多账号时userId和token会被覆盖
    // let token = cookie.getCookie('token');
    // let uid = cookie.getCookie('uid');
    let sessionStr = sessionStorage.getItem('userInfo')
    let session = sessionStr ? JSON.parse(sessionStr) : ''
    let uid = session ? session.userId : ''
    let token = session ? session.token : ''
    if (token) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers['token'] = token
      config.headers['uid'] = uid
    }
    return config
  },
  err => {
    return Promise.reject(err)
  }
)
// 拦截响应
axios.interceptors.response.use(
  response => {
    // if (response.data.code === 500 && response.data.msg.includes('token不存在或已过期')) {
    if (
      response.data.code === 500 &&
      ['token不存在或已过期', '用户未登录'].includes(response.data.msg)
    ) {
      cookie.clearCookie('token')
      router.replace({
        path: '/login'
      })
    }
    return response
  },
  err => {
    console.log(err)
    if (err.response) {
      switch (err.response.status) {
        case 401:
          cookie.clearCookie('token')
          router.replace({
            path: '/login'
          })
          break
      }
    }
    return Promise.reject(err)
  }
)
